import { Fancybox } from "@fancyapps/ui";

class FancyboxService {
    constructor() {
        document.addEventListener("DOMContentLoaded", function () {
            Fancybox.bind("body:not(.elementor-editor-active) [data-fancybox]", {});
        });
    }
}

export default FancyboxService;
